/**
 * Font size mappings for responsive design
 * Returns an object with xs (base) and lg (scaled) values
 * For sizes not in the mapping, xs and lg are the same
 */
export const fontSizes = {
  16: {
    xs: '12px',
    md: '14px',
    xl: '16px',
  },
  17: {
    xs: '12px',
    md: '16px',
    xl: '17px',
  },
  18: {
    xs: '14px',
    md: '18px',
  },
  20: {
    xs: '14px',
    md: '16px',
    xl: '20px',
  },
  22: {
    xs: '14px',
    md: '18px',
    xl: '22px',
  },
  24: {
    xs: '16px',
    md: '20px',
    xl: '24px',
  },
  26: {
    xs: '18px',
    md: '22px',
    xl: '26px',
  },
  30: {
    xs: '20px',
    md: '24px',
    xl: '30px', 
  },
  32: {
    xs: '14px',
    md: '28px',
    xl: '32px',
  },
  38: {
    xs: '20px',
    md: '30px',
    xl: '38px',
  },
  50: {
    xs: '30px',
    md: '40px',
    xl: '50px', 
  },
  80: {
    xl: '75px',
    md: '48px',
    xs: '33px', 
  },
  82: {
    xs: '35px',
    md: '42px',
    xl: '82px', 
  },
  94: {
    xs: '35px',
    md: '45px',
    xl: '94px',
  },
  14: {
    xs: '10px',
    md: '12px',
    xl: '14px', 
  },
  25: {
    xs: '16px',
    md: '20px',
    xl: '25px',
  },
  28: {
    xs: '20px',
    md: '24px',
    xl: '28px',
  },
  70: {
    xs: '35px',
    md: '45px',
    xl: '70px',
  },
  233: {
    xs: '50px',
    md: '70px',
    lg: '156px',
    xl: '233px',
  },
  270: {
    xs: '52px',
    md: "70px",
    lg: '156px',
    xl: '270px',
  },
};

/**
 * Get responsive font size object for a given base size
 * @param {number} baseSize - Base font size (e.g., 18, 20, 24)
 * @returns {object} - Object with xs and lg font sizes
 */
export const getFontSize = (baseSize) => {
  return fontSizes[baseSize] || {
    xs: `${baseSize}px`,
    lg: `${baseSize}px`,
  };
};
